import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=003c16df&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003c16df')) {
      api.createRecord('003c16df', component.options)
    } else {
      api.reload('003c16df', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=003c16df&", function () {
      api.rerender('003c16df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4seL8oHqL3Odi/JS/comp/FavElement.vue"
export default component.exports